import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    data:[],
    isFixing:false,
    status:null,
}

const token = userObj?.token

export const addPaymentError = createAsyncThunk(
    'wallets/addWalletPaymentLog',
    async (data, {rejectWithValue}) => {
        
        try{
            const response = await axios.post("/Wallets/AddWalletPaymentLog",data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const addPaymentErrorSlice = createSlice({
    name: 'addPaymentError',
    initialState,
    reducers: {},
    extraReducers:{
        [addPaymentError.pending]: (state, action) => {
            state.status='pending';
            state.isPaying=true;
        },
        [addPaymentError.fulfilled]: (state, action) => {
            state.status='success';
            state.isPaying=false;
            state.data = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [addPaymentError.rejected]: (state, action) => {
            state.status='failed';
            state.isPaying=false;
        }
    }
})

export default addPaymentErrorSlice.reducer;